import React, { Component } from 'react';
// import ReactDOM from "react-dom";
import { connect } from 'react-redux';
// import * as Contracts from '../../Store/Contracts';
import * as Monies from './Saga/Monies';


import './Css/Grid.css';
import moment from 'moment'

const ReactDataGrid = require('react-data-grid');
interface Props {
  get_banks: any,
  banks: [],
  shops: any,


}



interface State {
  columns: any
  // state types
}


const DateFormatter = (payload: any) => {
  if (payload.value) {
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};




const defaultColumnProperties = {
  sortable: true,
  // width: 120
};






/**
 *会計連動グリッド
 *
 * @class AccountingGridComponent
 * @extends {Component<Props, State>}
 */
class AccountingGridComponent extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);
    this.onRowClick = this.onRowClick.bind(this);

    this.state = {
      columns: [

        { key: 'date', name: '入金日', width: 100, resizable: true, formatter: DateFormatter },
        { key: 'created_at', name: '取込日', width: 100, resizable: true },
        { key: 'branch_id', name: '支店番号', width: 100, branch_id: true },
        { key: 'branch_name', name: '支店名', width: 80, resizable: true },
        { key: 'name', name: '振込名義', width: 150, resizable: true },
        { key: 'deposit_amount', name: '振込金額', width: 150, resizable: true },
        { key: 'remarks', name: '備考', width: 100, resizable: true },
        { key: 'account_type', name: '口座種別', width: 150, resizable: true },
        { key: 'account_number', name: '口座番号', width: 100, resizable: true },
        { key: 'account_name', name: '口座名義', width: 100, resizable: true },
        { key: 'section', name: '店舗名', width: 60, resizable: true },
        { key: 'building_name', name: '建物名', width: 60, resizable: true },
        { key: 'room_name', name: '部屋名', width: 60, resizable: true },
        { key: 'contract_money', name: '契約金', width: 60, resizable: true },

        { key: 'accounting_output_at', name: '出力日', width: 100, resizable: true },

      ].map(c => ({ ...c, ...defaultColumnProperties }))
    };

    this.sortRows = this.sortRows.bind(this);
    this.SectionFormatter = this.SectionFormatter.bind(this);
  }





  SectionFormatter = (payload: any) => {

    const result = this.props.shops.filter((x: any) => x.tenpoNo === payload.value);

    return result[0].tenpoName;

  };


  componentWillMount() {

    this.props.get_banks({ output: true, name: "", date1: "", date2: "" })


  }
  getSelectedCell(event: any) {
    alert()
  }

  onRowClick = (rowIdx: any, row: any) => {




  }


  // rowGetter = (i:number) => {
  //     return this.props.rent_contracts_list[i];
  //   };

  onRowsSelected = (rows: any) => {
    console.log(rows)
    rows.forEach(function (r: any) {
      r.row.selected = true;
    });

    this.forceUpdate();

  };

  onRowsDeselected = (rows: any) => {

    rows.forEach(function (r: any) {
      r.row.selected = false;
    });
    this.forceUpdate();
  };

  sortRows = (initialRows: any, sortColumn: any, sortDirection: any) => {


    const comparer = (a: any, b: any) => {
      if (sortDirection === "ASC") {

        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      } else {
        return 1;
      }
    };

    return sortDirection === "NONE" ? initialRows : this.props.banks.sort(comparer);
  };
  render() {

    return (
      <div>

        <ReactDataGrid
          // ref={node => this.grid = node}
          enableCellSelect={false}
          columns={this.state.columns}
          rowGetter={(i: number) => this.props.banks[i]}

          rowsCount={this.props.banks.length}
          headerRenderer={true}
          dragable={true}
          // onColumnResize={(idx, width) =>
          //     console.log(`Column ${idx} has been resized to ${width}`)
          // }
          // emptyRowsView={this.EmptyRowsView}
          // onRowClick={this.onRowClick}
          rowSelection={{
            showCheckbox: true,
            enableShiftSelect: true,
            onRowsSelected: this.onRowsSelected,
            onRowsDeselected: this.onRowsDeselected,
            selectBy: {
              isSelectedKey: 'selected'
              // indexes: this.state.selectedIndexes
            }
          }}
          onGridSort={(sortColumn: any, sortDirection: any) => { this.sortRows(this.props.banks, sortColumn, sortDirection) }
            //
          }
          //onCellSelected={this.getSelectedCell}
          minHeight={500} />
      </div>
    );
  }


}



const mapStateToProps = (state: any) => {
  return {
    // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
    shops: state.masterReducer.shops,
    banks: state.rentContractMoniesReducer.banks,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    // get_rent_contracts_list(state:any) {
    //     dispatch(Contracts.get_rent_contracts_list(state))
    // },
    get_banks(state: any) {
      dispatch(Monies.get_banks(state))
    },

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingGridComponent);